import { Pencil, Star, Trash2 } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { RowAction } from '@nucleus-commerce/admin-kit/index-table';
import type { StockLocation } from '@nucleus-commerce/api-client/admin';

export type LocationAction = 'edit' | 'makeDefault' | 'delete';

/** Edit, make default (not on the default) and delete; the page offers them only with `inventory.write`. */
export function useLocationRowActions(
  onAction: (action: LocationAction, location: StockLocation) => void,
) {
  const { t } = useTranslation('inventory');
  return useMemo<Array<RowAction<StockLocation>>>(
    () => [
      {
        id: 'edit',
        label: t('locations.actions.edit'),
        icon: <Pencil aria-hidden />,
        onAction: (location) => onAction('edit', location),
      },
      {
        id: 'makeDefault',
        label: t('locations.actions.makeDefault'),
        icon: <Star aria-hidden />,
        hidden: (location) => location.isDefault,
        onAction: (location) => onAction('makeDefault', location),
      },
      {
        id: 'delete',
        label: t('locations.actions.delete'),
        icon: <Trash2 aria-hidden />,
        variant: 'destructive',
        separatorBefore: true,
        onAction: (location) => onAction('delete', location),
      },
    ],
    [onAction, t],
  );
}
